<template>
  <UDashboardGroup unit="rem">
    <UDashboardPanel>
      <template #body>
        <slot />
      </template>
    </UDashboardPanel>
  </UDashboardGroup>
</template>

<script setup lang="ts"></script>

<style scoped></style>
